import { api } from '@bilibili-maoer/web-utils'

import { Avatar, Card, CardHeader, Typography, css, styled } from '@mui/material'

import { textOverflow } from '~/core/styles'
import type { FollowItemDetail } from '~/features/center/follow/types'

const StyledCardContainer = styled('a')`
  text-decoration: unset;
`

const StyledCard = styled(Card)(
  ({ theme }) => css`
    position: relative;
    border-radius: 4px;
    background-color: ${theme.palette.background.default};
    transition: 0.3s opacity;
    &:hover {
      opacity: 0.7;
    }
    &.active {
      &:before {
        content: '直播中';
        background-color: ${theme.palette.success.main};
      }
    }
    &:before {
      content: '暂无直播';
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      height: 18px;
      background-color: ${theme.palette.grey['500']};
      box-sizing: border-box;
      padding: 0 8px;
      line-height: 18px;
      color: ${theme.palette.info.contrastText};
      font-size: 10px;
      border-bottom-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    &:after {
      content: '';
      display: block;
      position: relative;
      clear: both;
    }
  `
)

const StyledCardTitle = styled(Typography)`
  ${textOverflow('186px')}
`

const StyledCardSubheader = styled(Typography)(
  ({ theme }) => css`
    color: ${theme.palette.text.primary};
  `
)

const FollowItem: React.FC<{ card: FollowItemDetail }> = ({ card }) => (
  <StyledCardContainer
    href={`${api.MISSEVAN_FM_API_PREFIX_URL}/live/${card.room_id}`}
    title={card.name}
    target="_blank"
  >
    <StyledCard variant="outlined" className={card.status.open ? 'active' : ''}>
      <CardHeader
        avatar={<Avatar src={card.creator_iconurl} alt={card.name} sx={{ width: '50px', height: '50px' }} />}
        title={<StyledCardTitle>{card.name}</StyledCardTitle>}
        subheader={<StyledCardSubheader>{`关注数 ${card.statistics.attention_count}`}</StyledCardSubheader>}
        sx={{ height: '80px' }}
      />
    </StyledCard>
  </StyledCardContainer>
)

export default FollowItem
